module.exports = __webpack_public_path__ + "static/img/6.3600a59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/6.png
// module id = O0wz
// module chunks = 1